import styled from 'styled-components';
import { COLORS } from '@ertelecom/ui-react/assets/js/constants';

export const Wrapper = styled.div`
    display: flex;
    width: 100%;
    margin: 70px 0 10px;
    user-select: none;
    @media (max-width: 500px) {
        margin: 25px 0 0;
    }
`;
export const MenuItem = styled.a`
    display: inline-block;
    align-self: center;
    padding: 12px 20px;
    font-family: Roboto;
    cursor: pointer;
    transition: color .2s;
    color: ${p => p.active ? COLORS.red : COLORS.darkGrey};
    &:hover {
        color: ${p => p.active ? COLORS.red : COLORS.lightRed};
    }
    &:first-of-type {
        padding-left: 2px;
    }
    @media (max-width: 500px) {
        padding: 10px 10px;
    }
    > span {
        font-size: 20px;
        line-height: 28px;
        display: inline-block;
        padding-bottom: 2px;
        ${p => p.active ? `border-bottom: 2px solid ${COLORS.red}` : ''};
        @media (max-width: 500px) {
            font-size: 14px;
        }
    }
`;
